import state from "@/store/modules/brand/state";
import actions from "@/store/modules/brand/actions";
import mutations from "@/store/modules/brand/mutations";
import getters from "@/store/modules/brand/getters";

export default {
    state,
    actions,
    mutations,
    getters
}